export const DELETE_SUCCESS = 'Прошивка удалена';
export const DELETE_ERROR = 'Не удалось удалить прошивку';
